import api from "services/api";
import { toSearchFilter } from "utils";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_EQUIPMENTS = API_URL_VERSION + "equipamentos";
export const ENDPOINT_EQUIPMENTS_LIST = ENDPOINT_EQUIPMENTS + "/listar";
export const ENDPOINT_EQUIPMENTS_SETTINGS = ENDPOINT_EQUIPMENTS + "/settings";

export const EquipmentType = {
  RADAR: {value: "RADAR", labelKey: "radar"},
  MOBILE: {value: "TALONARIO_ELETRONICO", labelKey: "mobile"}
}

export const equipmentsService = {
  list: async (params = {}) => {
    try {
      const response = await api.post(ENDPOINT_EQUIPMENTS_LIST, toSearchFilter(params));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.equipment.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_EQUIPMENTS, data);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.erros_validacao || "settings.equipment.messages.errors.create";
      throw new Error(errorMessage);
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_EQUIPMENTS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.equipment.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_EQUIPMENTS}/${id}`, data);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.erros_validacao || "settings.equipment.messages.errors.update";
      throw new Error(errorMessage);
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_EQUIPMENTS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.equipment.messages.errors.delete";
    }
  },

  settings: async (params = {}) => {
    try {
      const response = await api.get(ENDPOINT_EQUIPMENTS_SETTINGS);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.equipment.messages.errors.settings";
    }
  },

};
